import React from 'react';
import { RequestsDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import RequestDrillDownTableRow from '../RequestDrillDownTableRow/RequestDrillDownTableRow';

type RequestDrillDownTableBodyProps = {
  items: Array<RequestsDrillDownItem>;
  readOnly?: boolean;
};

const RequestDrillDownTableBody: React.FC<RequestDrillDownTableBodyProps> = ({
  items,
  readOnly = false,
}) => {
  return (
    <tbody>
      {items.map((item) => (
        <RequestDrillDownTableRow
          key={item.id}
          item={item}
          readOnly={readOnly}
        />
      ))}
    </tbody>
  );
};

export default RequestDrillDownTableBody;
